import {
  ApiResponse,
  Clinic,
  PaginationQuery,
  PaginationResponse,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UseClinicsParams extends PaginationQuery {
  search?: string
  providerId?: number
  clinicGroupId?: number
}

export function useClinics({ page = 1, pageSize = 10, search, providerId, clinicGroupId }: UseClinicsParams) {
  const { token } = useAuth()

  // Build params object instead of URL string concatenation
  const params: Record<string, unknown> = {
    page,
    pageSize,
  }

  if (search) {
    params.search = search
  }

  if (providerId) {
    params.providerId = providerId
  }

  if (clinicGroupId) {
    params.clinic_group_id = clinicGroupId
  }

  const { data, error, mutate, isValidating } = useGet<ApiResponse<PaginationResponse<Clinic>>>(
    token ? '/api/clinics' : null,
    params,
    token ?? '',
    undefined,
    {
      keepPreviousData: true, // Keep previous data while loading new data
    },
  )

  return {
    clinics: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isValidating,
    isError: error,
    mutate,
  }
}
